import { Component, Input, type OnDestroy, type OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { type User } from '@inside-hub-app/customer-portal-b2c-client'
import { NGXLogger } from 'ngx-logger'
import { DataService } from '../../../../services/data.service'
import { VehicleDTOExtended } from '../../../../services/vehicles.service'

import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { SharedService } from '../../../../services/shared.service'
import { InsuranceService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { SkeletonLoaderComponent } from '../skeleton-loader/skeleton-loader.component'
import { RevolutionServiceMoleculeComponent } from '../service-molecule/service-molecule.component'
@Component({
  selector: 'customer-portal-app-revolution-vehicle-service-package-and-insurance',
  standalone: true,
  templateUrl: './vehicle-service-package-and-insurance.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    SkeletonLoaderComponent,
    RevolutionServiceMoleculeComponent
  ]
})
export class VehicleServicePackageAndInsuranceComponent
implements OnInit, OnDestroy {
  public hasInsurance
  user: User
  loadingServicePackage: boolean
  loadingInsurance: boolean
  maintenanceLoaded = false

  componentSub = {
    UserLoaded: null,
    servicePackage: null,
    loadingInsurance: null
  }

  constructor (
    public dialog: MatDialog,
    private readonly logger: NGXLogger,
    private readonly dataService: DataService,
    public readonly sharedService: SharedService,
    private readonly insuranceService: InsuranceService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.hasInsurance = this.remoteConfigService.get('hasInsurance')
    this.componentSub.UserLoaded = this.dataService.onUserLoaded.subscribe(
      user => {
        this.user = user
      }
    )
    this.componentSub.servicePackage =
      this.dataService.loading.servicePackage.subscribe(loading => {
        this.loadingServicePackage = loading
      })

    this.componentSub.loadingInsurance = this.insuranceService.loadingInsurance.subscribe(loading => {
      this.loadingInsurance = loading
    })
  }

  @Input()
  public vehicle: VehicleDTOExtended

  @Input()
  public vin: string

  exists = true

  ngOnInit (): void {
    if (this.vehicle == null) {
      this.exists = false
    }
  }

  ngOnDestroy (): void {
    this.componentSubUnsubscribe()
  }

  componentSubUnsubscribe (): void {
    for (const sub in this.componentSub) {
      try {
        this.componentSub[sub].unsubscribe()
      } catch (error) {
        // no need to show log
      }
    }
  }

  dataIsLoading (): boolean {
    let SPLoading = false
    if (this.sharedService.showServicePackageSection()) {
      SPLoading = this.loadingServicePackage
    }
    let insuranceLoading = false
    if (this.hasInsurance === true) {
      insuranceLoading = this.loadingInsurance
    }

    return (SPLoading || insuranceLoading)
  }
}
